var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormik } from 'formik';
import { useEffect } from 'react';
import { useState } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import Modal from 'react-modal';
import { useHistory } from 'react-router-dom';
import useAuth from '../../../hooks/useAuth';
import api from '../../../services/api';
import * as Yup from 'yup';
import styles from './styles.module.scss';
import { Button, InputSelect, InputText } from 'template/lib';
// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('#root');
var ModalCompany = function (props) {
    var _a = useState([]), companiesState = _a[0], setCompaniesState = _a[1];
    var _b = useState([]), supportOpt = _b[0], setSupportOpt = _b[1];
    var _c = useState([]), modalitiesOpt = _c[0], setModalities = _c[1];
    var history = useHistory();
    var _d = useAuth(), login = _d.login, handleLogout = _d.handleLogout;
    var config = {
        headers: { Authorization: "Bearer " + (login === null || login === void 0 ? void 0 : login.token) }
    };
    useEffect(function () {
        if (login && Date.now() > (login === null || login === void 0 ? void 0 : login.expiresIn) * 1000) {
            handleLogout();
            history.push('/');
        }
        if (!login) {
            history.push('/');
        }
        api.get('companies/getSupportUsers', config).then(function (response) {
            setSupportOpt(response.data);
        });
        api.get('companies/getModalities', config).then(function (response) {
            setModalities(response.data);
        });
    }, []);
    var compnaySchema = Yup.object().shape({
        helper: Yup.string()
            .required('O campo Técnico responsável é obrigatório.'),
        name: Yup.string()
            .required('O campo Nome é obrigatório.')
            .max(50, 'O campo Nome deve conter no máximo 50 caracteres.'),
        wpsId: Yup.number()
            .required('O campo Wps Id é obrigatório.')
            .moreThan(0, 'O campo Wps Id deve ser maior que zero.')
            .max(2147483647, 'O valor máximo para o campo Wps Id é 2147483647.'),
        cpf: Yup.string()
            .nullable()
            .matches(/^[0-9]+$/, 'O campo CPF deve conter apenas números.')
            .min(11, 'O campo CPF deve conter 11 dígitos.')
            .max(11, 'O campo CPF deve conter 11 dígitos.'),
        cnpj: Yup.string()
            .nullable()
            .matches(/^[0-9]+$/, 'O campo CNPJ deve conter apenas números.')
            .min(14, 'O campo CNPJ deve conter 14 dígitos.')
            .max(14, 'O campo CNPJ deve conter 14 dígitos.')
    });
    var formik = useFormik({
        initialValues: {
            name: '',
            helper: '',
            wpsId: '',
            cpf: '',
            cnpj: '',
            isImplantation: false,
            modality: null,
        },
        validationSchema: compnaySchema,
        onSubmit: function (values, actions) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                api.post("companies", values, config).then(function (response) {
                    actions.resetForm({
                        values: {
                            name: '',
                            helper: '',
                            wpsId: '',
                            cpf: '',
                            cnpj: '',
                            isImplantation: false,
                            modality: null,
                        },
                    });
                    props.setId(response.data);
                    props.handlecloseModalCompany();
                });
                return [2 /*return*/];
            });
        }); }
    });
    var columns = 1;
    var companyState = {
        label: 'Status da empresa',
        options: companiesState
    };
    var SupportUsers = {
        label: 'Técnico responsável',
        options: supportOpt
    };
    var Modalities = {
        label: 'Modalidade',
        options: modalitiesOpt
    };
    return (_jsx("div", { children: _jsx(Modal, __assign({ isOpen: props.modalIsOpenCompany, shouldCloseOnOverlayClick: false, onRequestClose: props.handlecloseModalCompany, overlayClassName: 'react-modal-overly', className: 'react-modal-content', contentLabel: "Example Modal" }, { children: _jsxs("div", __assign({ className: '' }, { children: [_jsxs("div", __assign({ className: styles.header }, { children: [_jsx("div", {}, void 0), _jsx("h2", __assign({ className: ' font-semibold border-b-2 text-lg' }, { children: "Adicionar Empresa" }), void 0), _jsx(AiOutlineClose, { title: 'Fechar', className: 'cursor-pointer text-sm', onClick: props.handlecloseModalCompany }, void 0)] }), void 0), _jsx("div", __assign({ className: styles.content }, { children: _jsxs("form", __assign({ onSubmit: formik.handleSubmit, className: 'mx-4 my-4' }, { children: [_jsx("div", __assign({ className: 'grid justify-items-start' }, { children: _jsxs("div", __assign({ className: "grid grid-cols-1 md:grid-cols-" + columns + " lg:grid-cols-" + columns + " my-2 justify-items-end" }, { children: [_jsx(InputSelect, { value: formik.values.helper, name: 'helper', onChange: formik.handleChange, values: SupportUsers, valueMember: 'id', displayMember: 'name' }, void 0), _jsx(InputText, { onChange: formik.handleChange, name: 'name', label: 'Nome', inicialValue: formik.values.name }, void 0), _jsx(InputText, { onChange: formik.handleChange, name: 'wpsId', label: 'Wps Id', inicialValue: formik.values.wpsId }, void 0), _jsx(InputText, { onChange: formik.handleChange, name: 'cpf', label: 'CPF', inicialValue: formik.values.cpf }, void 0), _jsx(InputText, { onChange: formik.handleChange, name: 'cnpj', label: 'CNPJ', inicialValue: formik.values.cnpj }, void 0), _jsxs("div", __assign({ className: styles.containerCheckBoxInput }, { children: [_jsx("label", __assign({ className: styles.labelImplantationa }, { children: "Implanta\u00E7\u00E3o:" }), void 0), _jsx("input", { onChange: formik.handleChange, name: 'isImplantation', type: "checkbox", checked: formik.values.isImplantation }, void 0)] }), void 0), _jsx(InputSelect, { resize: false, value: formik.values.modality, name: 'modality', onChange: formik.handleChange, values: Modalities, valueMember: 'id', displayMember: 'name' }, void 0), formik.errors.helper && formik.touched.helper && _jsx("i", __assign({ className: 'w-full flex justify-center text-red-400' }, { children: formik.errors.helper }), void 0), formik.errors.name && formik.touched.name && _jsx("i", __assign({ className: 'w-full flex justify-center text-red-400' }, { children: formik.errors.name }), void 0), formik.errors.wpsId && formik.touched.wpsId && _jsx("i", __assign({ className: 'w-full flex justify-center text-red-400' }, { children: formik.errors.wpsId }), void 0), formik.errors.cpf && formik.touched.cpf && _jsx("i", __assign({ className: 'w-full flex justify-center text-red-400' }, { children: formik.errors.cpf }), void 0), formik.errors.cnpj && formik.touched.cnpj && _jsx("i", __assign({ className: 'w-full flex justify-center text-red-400' }, { children: formik.errors.cnpj }), void 0)] }), void 0) }), void 0), _jsx("div", __assign({ className: styles.flexButton }, { children: _jsx(Button, __assign({ type: 'submit', className: '' }, { children: "Salvar" }), void 0) }), void 0)] }), void 0) }), void 0)] }), void 0) }), void 0) }, void 0));
};
export default ModalCompany;
